import { useEffect, useState } from "react";
import { ChevronUp } from "lucide-react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      data-testid="back-to-top-button"
      aria-label="Voltar ao topo"
      className={`fixed bottom-6 left-6 z-40 w-10 h-10 bg-white border border-gray-200 rounded-full flex items-center justify-center shadow-lg text-[#212121]/50 hover:border-[#0D47A1] hover:text-[#0D47A1] hover:-translate-y-0.5 hover:shadow-xl transition-all duration-200 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <ChevronUp size={18} />
    </button>
  );
}
